import React from 'react';
import PropTypes from 'prop-types';
import SignedFileProp from '../propTypes/signedFileProp';
import UserColumn from '../lists/columns/UserColumn';
import translate from '../translate';
import StatusLabel from '../StatusLabel';
import FileIcon from '../icons/FileIcon';
import RemoveIcon from '../icons/icon/RemoveIcon';

function SignedDocumentsListItem(props) {
  const { t, file, size, onRemoveClick } = props;
  const { taskStatus } = file || {};
  return (
    <div className="signedDocumentsListItem-container">
      {onRemoveClick ? (
        <button
          onClick={event => {
            event.stopPropagation();
            onRemoveClick();
          }}
          type="button"
          className="document-remove"
        >
          <RemoveIcon color="#ff36a6" />
        </button>
      ) : null}
      <a
        className={`signed-documents-list-item ${
          size === 'small' ? 'small' : ''
        }`}
        href={file?.documents?.url}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FileIcon ext={file?.documents?.ext} />
        <div className="signed-documents-list-item-title">
          {file.documents.originalName}
        </div>
        {file?.owner?._id ? (
          <div className="signed-documents-list-item-user-column">
            <UserColumn t={t} user={file.owner} />
          </div>
        ) : (
          <div className="signed-documents-list-item-subtitle">
            {file?.journey?.title}
          </div>
        )}
        {taskStatus ? <StatusLabel status={taskStatus} showContainer /> : null}
      </a>
    </div>
  );
}

SignedDocumentsListItem.propTypes = {
  t: PropTypes.func.isRequired,
  file: PropTypes.shape(SignedFileProp.propType).isRequired,
  size: PropTypes.oneOf(['small', 'regular']),
  onRemoveClick: PropTypes.func,
};

SignedDocumentsListItem.defaultProps = {
  size: 'regular',
  onRemoveClick: null,
};

const memoized = React.memo(translate(SignedDocumentsListItem));
memoized.displayName = 'SignedDocumentsListItem';
export default memoized;
